import React, {Component} from 'react'
import {connect} from 'react-redux'
import {Mask} from 'react-weui'
import '../styles/ImagePreviewer.css'


class ImagePreviewer extends Component {
    constructor() {
        super()
        this.hideImagePreviewer = this.hideImagePreviewer.bind(this)
    }

    hideImagePreviewer() {
        this.props.dispatch({type: 'HIDE_IMAGE_PREVIEWER'})
    }

    render() {
        const {showImagePreviewer, imageUrl} = this.props.imagePreviewer

        if (!showImagePreviewer) {
            return null
        }

        return (
            <div className="image-previewer"  onClick={this.hideImagePreviewer}>
                <Mask />
                <div className="image-previewer-container">
                    <img className="picture" src={imageUrl}/>
                </div>
            </div>
        )
    }
}

export default connect((state) => ({
    imagePreviewer: state.imagePreviewer
}))(ImagePreviewer)




// WEBPACK FOOTER //
// ./src/components/ImagePreviewer.js